import { useEffect } from "react";
import { useSiteSettings } from "@/hooks/use-site-settings";
import { applyGlobalFont, DEFAULT_FONT_ID } from "@/lib/fonts";

/**
 * Reads the `global_font` site setting and applies it across the whole site
 * by swapping --font-body / --font-display CSS variables. Mounted once at
 * the app root so every page (including admin, cart, checkout, mobile) uses it.
 */
export default function FontLoader() {
  const { data: settings } = useSiteSettings();
  const fontId = settings?.global_font || DEFAULT_FONT_ID;

  useEffect(() => {
    applyGlobalFont(fontId);
  }, [fontId]);

  return null;
}
